import { useNetworkState } from '@lbcamden/lib-react';
import { useEffect } from 'react';

import { useSyncPropertyData } from '~/client/components/containers/AppContainer/useManageSyncStores/useSyncPropertyData';
import { useIsUserRegistered } from '~/client/hooks/authHooks';
import {
  useGlobalStore,
  useGlobalStoreSyncStatus,
  useCurrentUser,
} from '~/client/hooks/storeHooks';
import { UiReactGlobal } from '~/client/hooks/storeHooks/uiReactWithSchemas';
import { useTinybaseStore } from '~/client/store/tinybase/tinybaseStore';

export const useManageSyncStores = () => {
  const { online } = useNetworkState();

  const user = useCurrentUser();

  const userStoreCrypto = useTinybaseStore((state) => state.userStoreCrypto);
  const syncStores = useTinybaseStore((state) => state.syncStores);
  const createSyncStores = useTinybaseStore((state) => state.createSyncStores);
  const initialSyncProgress = useTinybaseStore((state) => state.initialSyncProgress);
  const setHasCompletedInitialSync = useTinybaseStore((state) => state.setHasCompletedInitialSync);

  const globalStore = useGlobalStore();
  const hasGlobalTables = UiReactGlobal.useHasTables(globalStore?.store);
  const globalStoreSyncStatus = useGlobalStoreSyncStatus();

  const { isRegistered } = useIsUserRegistered();

  // User must be online for the stores initialisation
  const shouldCreateSyncStores = user && isRegistered && online && userStoreCrypto && !syncStores;
  const hasGlobalStoreData = hasGlobalTables && globalStoreSyncStatus !== 1;

  useSyncPropertyData();

  useEffect(() => {
    if (shouldCreateSyncStores) {
      void createSyncStores(user.id);
    }
  }, [shouldCreateSyncStores]);

  // Only start sync once syncStores is globally accessible
  // to ensure the listener hooks have been setup
  useEffect(() => {
    if (syncStores) {
      void syncStores.startSync();
    }
  }, [syncStores]);

  useEffect(() => {
    if (initialSyncProgress.syncStarted && hasGlobalStoreData) {
      setHasCompletedInitialSync();
    }
  }, [initialSyncProgress, hasGlobalStoreData]);

  useEffect(() => {
    if (syncStores) {
      syncStores.userStore.setIsConnected(!!online);
    }
  }, [online]);
};
